import { EXPRESS_API } from 'configs/api/expressApi';
import { CreateParams } from '.';

export const getVideoDelete = async () => {
  const response = await EXPRESS_API.get('/video-deletes');
  const videoDelete: any = response.data || {};
  return { videoDelete };
};

export const createVideoDelete = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.post('/video-deletes', data);
  return response.data;
};

export const updateVideoDelete = async (data: any) => {
  const response = await EXPRESS_API.put(
    `/video-deletes/${data.deleteId}`,
    data
  );
  return response.data;
};

export const deleteVideoDelete = async (videoDeleteId: string) => {
  await EXPRESS_API.delete(`/video-deletes/${videoDeleteId}`);
  return { videoDeleteId };
};

export const createStopVideoDeleteRequest = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.post('/stop-video-deletes', data);
  return response.data;
};

export const approveVideoDelete = async (data: any) => {
  const response = await EXPRESS_API.put(
    `/stop-video-deletes/${data.requestId}/approve`,
    data
  );
  return response.data;
};
export const denyVideoDelete = async (data: any) => {
  const response = await EXPRESS_API.put(
    `/stop-video-deletes/${data.requestId}/deny`,
    data
  );
  return response.data;
};

export const getVideosForCustomer = async (days: number) => {
  const response = await EXPRESS_API.get(`/video-deletes/videos`, {
    params: { days },
  });
  return response.data;
};
